import { createSelector } from '@ngrx/store';
import { IRootState } from '../../../root';
import { IPersonaState } from './persona.state';

export class PersonaSelectors {
  // todo: replace any type state with root state (once defined)
  static readonly personaState = (state: IRootState): IPersonaState => {
    return state.persona as IPersonaState;
  };

  static readonly model = createSelector(PersonaSelectors.personaState, (persona: IPersonaState) => {
    return persona.model;
  });

  static readonly data = createSelector(PersonaSelectors.personaState, (persona: IPersonaState) => {
    return persona.data;
  });
}
